export const LOCALE = process.env.REACT_APP_LOCALE;
export const VALID_LOCALES = ["en", "id", "zh", "ja"];
export const COUNTRY = process.env.REACT_APP_COUNTRY;
export const ECOM_API_KEY = process.env.REACT_APP_ECOM_API_KEY;
export const ENV = process.env.REACT_APP_ENV;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const GOOGLE_RECAPTCHA_CLIENT_KEY =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_CLIENT_KEY;
export const GOOGLE_RECAPTCHA_ENTERPRISE_CLIENT_KEY =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_ENTERPRISE_CLIENT_KEY;
export const ROLLBAR_ACCESS_TOKEN = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN;
export const ADOBE_LAUNCH_CODE = process.env.REACT_APP_ADOBE_LAUNCH_CODE;
export const CLEVERTAP_ACCOUNT_ID = process.env.REACT_APP_CLEVERTAP_ACCOUNT_ID; // used by legacy
export const FACEBOOKPIXEL_ACCOUNT_ID =
  process.env.REACT_APP_FACEBOOKPIXEL_ACCOUNT_ID;
export const TIKTOKPIXEL_ACCOUNT_ID =
  process.env.REACT_APP_TIKTOKPIXEL_ACCOUNT_ID;
export const MYINFO_ENDPOINT = process.env.REACT_APP_MYINFO_ENDPOINT;
export const MYINFO_CLIENT_ID = process.env.REACT_APP_MYINFO_CLIENT_ID;
export const CIRCLES_PAYMENT_PLUGIN_ORIGIN_KEY =
  process.env.REACT_APP_ORIGIN_KEY;
export const CIRCLES_PAYMENT_PLUGIN_PATH =
  process.env.REACT_APP_CIRCLES_PAYMENT_PLUGIN_PATH;
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Circles.Life";
export const BRAND_FAVICON =
  process.env.REACT_APP_BRAND_FAVICON || "circles.life.ico";
export const BRAND_TITLE =
  process.env.REACT_APP_BRAND_TITLE ||
  "Finally a telco for the people, by the people. | Circles.Life";
export const BRAND_DESCRIPTION =
  process.env.REACT_APP_BRAND_DESCRIPTION || "The Best No-contract Mobile Plan";
export const SESSION_TIMEOUT = process.env.REACT_APP_SESSION_TIMEOUT || 55;
export const PAYMENT_STATUS_POLL_INTERVAL =
  process.env.REACT_APP_PAYMENT_STATUS_POLL_INTERVAL || 5000;
export const IDENTITY_CHECK_POLL_MAX_COUNT = 6;
export const OLD_WEBFRONT_URL = process.env.REACT_APP_OLD_WEBFRONT_URL || "";
export const MOBILE_APP_DEEP_LINK =
  process.env.REACT_APP_MOBILE_APP_DEEP_LINK || "";
export const MOBILE_APP_BROWSER_PROTOCOL = "browser";
export const GTM_ID = process.env.REACT_APP_GTM_ID || "";
export const DELIVERY_SLOT_TYPE_SAD_SIM = "sad-sim-only";
export const DELIVERY_SLOT_TYPE_SIM = "sim-only";
export const DELIVERY_SLOT_TYPE_SIM_AND_PHONE = "sim-and-phone";
export const DELIVERY_SLOT_TYPE_PHONE = "phone-only";
export const IOS_DEVICE = "ios";
export const ANDROID_DEVICE = "android";
export const USE_REWARDS_CIS = process.env.REACT_APP_USE_REWARDS_CIS === "true";
export const TELCO_TENANT = process.env.REACT_APP_TELCO_TENANT;
export const PAYMENT_ENVIRONMENT =
  process.env.REACT_APP_PAYMENT_ENVIRONMENT || "TEST";
export const GOOGLE_EMBED_MAP_URL =
  "https://www.google.com/maps/embed/v1/place";

export const COUNTRIES_WITH_API_GATEWAY = ["jp"];
export const COUNTRIES_WITH_SECURED_PATHS = ["jp"];
// export const COUNTRIES_WITH_LEGACY_APP = ["sg"];
// export const LEGACY_APP_ENABLED = COUNTRIES_WITH_LEGACY_APP.includes(COUNTRY);
export const USE_API_GATEWAY = COUNTRIES_WITH_API_GATEWAY.includes(COUNTRY);
export const IS_PATHS_SECURED = COUNTRIES_WITH_SECURED_PATHS.includes(COUNTRY);
export const PORTING_ACCOUNTS = process.env.REACT_APP_PORTING_ACCOUNTS || "";
export const USE_OMS_API_GATEWAY =
  process.env.REACT_APP_USE_OMS_API_GATEWAY === "true";

/******* PLASMIC Variables ***/
export const PLASMIC_ID = process.env.REACT_APP_PLASMIC_ID || "";
export const PLASMIC_TOKEN = process.env.REACT_APP_PLASMIC_TOKEN || "";

/******* ACYEN Variables ***/
export const ACYEN_USERNAME = process.env.REACT_APP_ACYEN_USERNAME || "";
export const ACYEN_PASSWORD = process.env.REACT_APP_ACYEN_PASSWORD || "";
export const ACYEN_TOKEN_URL = process.env.REACT_APP_ACYEN_TOKEN_URL || "";
export const ACYEN_SHIPPING_CARRIER_URL =
  process.env.REACT_APP_ACYEN_SHIPPING_CARRIER_URL || "";
export const ACYEN_VENDOR_CHANNEL_ID =
  process.env.REACT_APP_ACYEN_VENDOR_CHANNEL_ID || "";

/******* THEME COLORS *******/
export const SECONDARY_COLOR =
  process.env.REACT_APP_BRAND_SECONDARY_COLOR || "#C51398";
export const PRIMARY_COLOR =
  process.env.REACT_APP_BRAND_PRIMARY_COLOR || "#0000FF";
export const SPINNER_COLOR =
  process.env.REACT_APP_BRAND_SPINNER_COLOR || "#0000FF";

/******* Base URLS *******/
export const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;
export const MOBILE_APP_DEEP_LINK_QA =
  process.env.REACT_APP_MOBILE_APP_DEEP_LINK_QA;

export const BASE = {
  OMS: "OMS",
  OMS_API_GATEWAY: "OMS_API_GATEWAY",
  USER_SERVICE: "USER_SERVICE",
  API_GATEWAY: "API_GATEWAY",
  LOGISTIC: "LOGISTIC",
  PAYMENTS: "PAYMENTS",
  PAYMENTS_SERVICE: "PAYMENTS_SERVICE",
  REWARDS: "REWARDS",
  MOBILE_API: "MOBILE",
  TELCO_SERVICE: "TELCO_SERVICE",
  TELCO_PORT_IN_SERVICE: "TELCO_PORT_IN_SERVICE",
  QUILT_SERVICE: "QUILT_SERVICE",
  REWARDS_SERVICE: "REWARDS_SERVICE",
  BILLING: "BILLING",
  MOCK: "MOCK",
  FULFILLMENT: "FULFILLMENT"
};

export const BASE_URL = {
  [BASE.OMS]: process.env.REACT_APP_OMS_URL || API_GATEWAY_URL,
  [BASE.OMS_API_GATEWAY]: API_GATEWAY_URL,
  [BASE.USER_SERVICE]:
    process.env.REACT_APP_USER_SERVICE_URL || API_GATEWAY_URL,
  [BASE.PAYMENTS]: API_GATEWAY_URL,
  [BASE.PAYMENTS_SERVICE]:
    process.env.REACT_APP_PAYMENT_SERVICE_URL || API_GATEWAY_URL,
  [BASE.QUILT_SERVICE]:
    process.env.REACT_APP_QUILT_SERVICE_URL || API_GATEWAY_URL,
  [BASE.TELCO_SERVICE]:
    process.env.REACT_APP_TELCO_SERVICE_URL || API_GATEWAY_URL,
  [BASE.TELCO_PORT_IN_SERVICE]:
    process.env.REACT_APP_TELCO_SERVICE_URL || API_GATEWAY_URL,
  [BASE.API_GATEWAY]: API_GATEWAY_URL,
  [BASE.LOGISTIC]: API_GATEWAY_URL,
  [BASE.REWARDS]: API_GATEWAY_URL,
  [BASE.REWARDS_SERVICE]: API_GATEWAY_URL,
  [BASE.MOBILE_API]: API_GATEWAY_URL,
  [BASE.BILLING]: API_GATEWAY_URL,
  [BASE.MOCK]: "https://3881dd17-8050-43dc-92fa-08c7da9cd1a7.mock.pstmn.io",
  [BASE.FULFILLMENT]: process.env.REACT_APP_FULFILLMENT_URL,
};

export const OMS_URL = BASE_URL[BASE.OMS];
export const USER_SERVICE_URL = BASE_URL[BASE.USER_SERVICE];

/******** API version paths ********/
export const VERSION_PATH = {
  [BASE.OMS]: `/api/{VERSION}/${COUNTRY}/webfront`,
  [BASE.OMS_API_GATEWAY]: `/{VERSION}/${COUNTRY}/{LOCALE}/webfront/oms`,
  [BASE.USER_SERVICE]: "/api/{VERSION}/user-service",
  [BASE.API_GATEWAY]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/webfront`,
  [BASE.LOGISTIC]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/webfront/laas`,
  [BASE.PAYMENTS]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/webfront`,
  [BASE.PAYMENTS_SERVICE]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/webfront`,
  [BASE.MOBILE_API]: `/{VERSION}/${COUNTRY}/{LOCALE}/mobile`,
  [BASE.REWARDS]: "/{VERSION}/ecom/raas",
  [BASE.QUILT_SERVICE]: "/api/{VERSION}/quilt",
  [BASE.TELCO_SERVICE]: `/{VERSION}/${COUNTRY}/{LOCALE}-${COUNTRY.toUpperCase()}/${TELCO_TENANT}`,
  [BASE.TELCO_PORT_IN_SERVICE]: `/{VERSION}/${COUNTRY}/{LOCALE}/${TELCO_TENANT}`,
  [BASE.REWARDS_SERVICE]: `/{VERSION}/${COUNTRY}/{LOCALE}/mobile/rewards`,
  [BASE.BILLING]: `/{VERSION}/${COUNTRY}/{LOCALE}/webfront`,
  [BASE.MOCK]: `/api/{VERSION}/${COUNTRY}/webfront`,
  [BASE.FULFILLMENT]: "/api/{VERSION}",
};

export const OMS_VERSION_PATH = VERSION_PATH[BASE.OMS];
export const USER_SERVICE_VERSION_PATH = VERSION_PATH[BASE.USER_SERVICE];
export const API_GATEWAY_VERSION_PATH = VERSION_PATH[BASE.API_GATEWAY];

export const DEFAULT_API_VERSION = {
  [BASE.OMS]: "v3",
  [BASE.OMS_API_GATEWAY]: "v3",
  [BASE.USER_SERVICE]: "v3",
  [BASE.API_GATEWAY]: "v4",
  [BASE.LOGISTIC]: "v1",
  [BASE.PAYMENTS]: "v4",
  [BASE.PAYMENTS_SERVICE]: "v3",
  [BASE.REWARDS]: "v1",
  [BASE.MOBILE_API]: "v4",
  [BASE.QUILT_SERVICE]: "v1",
  [BASE.TELCO_SERVICE]: "v1",
  [BASE.TELCO_PORT_IN_SERVICE]: "v2",
  [BASE.REWARDS_SERVICE]: "v4",
  [BASE.BILLING]: "v4",
  [BASE.MOCK]: "v3",
  [BASE.FULFILLMENT]: "v1"
};

/****** APIs *******/
export const OMS_APP_SETTINGS = "/checkout/app_settings";
export const OMS_LOCALE = "/locale";
export const OMS_BASE_PLAN = "/checkout/base_plan";
export const OMS_ELIGIBLE_PLANS = "/checkout/eligible_plans";
export const OMS_DELIVERY_SLOTS = "/checkout/delivery_slots";
export const OMS_NUMBERS = "/checkout/numbers";
export const OMS_PHONES = "/checkout/phones";
export const OMS_POST_OFFICE_DELIVERY_SLOTS =
  "/checkout/post_office_delivery_slots";
export const OMS_ORDER_STATUS = "/orders/status";
export const OMS_GET_AUTHORIZER = "/orders/get_authorizer";
export const OMS_SET_AUTHORIZER = "/orders/set_authorizer";
export const OMS_GUEST_ORDER = "/orders/guest_order";
export const OMS_DO_KYC = "/orders/do_kyc";
export const OMS_VALIDATE_REFERRAL_CODE = "/checkout/verify_referral_code";
export const OMS_VALIDATE_PORT_IN_NUMBER = "/checkout/port_number_check";
export const OMS_VALIDATE_POSTAL_CODE = "/checkout/check_postal_valid";
export const OMS_SEARCH_ADDRESS_LOOKUP = "/checkout/search_address_lookup";
export const OMS_LOAD_ADDRESS_LOOKUP = "/checkout/load_address_lookup";
export const OMS_FIND_ADDRESS_LOOKUP = "/checkout/find_address_lookup";
export const OMS_ADDRESS_COMPONENT_MAPPINGS =
  "/checkout/address_component_mappings";
export const OMS_NUMBER_LOCK = "/checkout/number_lock";
export const OMS_VERIFY_SELF_ACTIVATION_DELIVERY_NRIC =
  "/checkout/sad/validate_nric";
export const OMS_VERIFY_IDENTITY = "/checkout/verify_identity";
export const OMS_VALIDATE_ICCID = "/checkout/validate_iccid";
export const OMS_SAD_VALIDATE_ICCID = "/checkout/sad_order/validate_identity";
export const OMS_ORDER_DETAILS = "/orders/details";
export const OMS_PAYMENT_RETURN = "/orders/payment_details";
export const OMS_SELF_ACTIVATION_DELIVERY = "/orders/details";
export const OMS_SUSPENSION_PAYMENT_DETAILS = "/suspension/payment_details";
export const OMS_SUBMIT_NUMBER_CHANGE = "/number_change/submit";
export const OMS_CANCEL_NUMBER_CHANGE = "/number_change/cancel";
export const OMS_SUBMIT_SUSPENSION = "/suspension/submit";
export const OMS_CANCEL_SUSPENSION = "/suspension/cancel";
export const OMS_SUBMIT_WINBACK = "/termination/winback";
export const OMS_SUBMIT_TERMINATION = "/termination/submit";
export const OMS_CANCEL_TERMINATION = "/termination/cancel";
export const OMS_CANCEL_PORT_IN = "/orders/cancel_port_in";
export const OMS_REINITIATE_PORT_IN =
  "/orders/reinitiate_portin_update_details";
export const OMS_RESCHEDULE_PORT_IN = "/orders/reschedule_port_in";
export const OMS_ACTIVATE_SIM_CARD = "/orders/activate_sim_card";
export const OMS_ACTIVATE_SIM_REPLACEMENT = "/orders/activate_sim_replacement";
export const OMS_CREATE_ORDER = "/orders/create_order";
export const OMS_CREATE_ORDER_TEMP = "/orders/create_order_temp";
export const OMS_UPDATE_SAD_ORDER = "/orders/sad_orders";
export const OMS_UPDATE_ORDER = "/orders/update_order";
export const OMS_RESEND_ESIM_QR_CODE = "/orders/send_esim_qr_code";
export const OMS_CREATE_SAD_ORDER = "/orders/sad_orders";
export const OMS_EKYC_COMPLETED = "/checkout/ekyc_completed";
export const OMS_FETCH_ORDER_STATUS = "/orders/status";
export const OMS_CONFIRM_PAYMENT_OPTION = "/paas/ecpay/confirm_payment_option";
export const OMS_FETCH_PAYMENT_REQUEST = "/orders/payment_request";
export const OMS_SECURED_FETCH_PAYMENT_REQUEST =
  "/orders/secured_payment_request";
export const OMS_VERIFY_PAYMENT = "/orders/verify_payment";
export const OMS_SUBMIT_REPLACE_SIM = "/replace_sim/submit";
export const OMS_SUBMIT_SWITCH_TO_ESIM = "/replace_sim/submit";
export const OMS_DELIVERY_INFO = "/deliveries/info";
export const OMS_SUBMIT_DELIVERY = "/deliveries/submit";
export const OMS_UPLOAD_IDENTITY_DETAILS = "/identities/info";
export const OMS_SUBMIT_UPLOAD_IDENTITY = "/identities/submit";
export const OMS_FETCH_SURVEY = "/surveys/new";
export const OMS_SUBMIT_SURVEY = "/surveys/submit";
export const OMS_IDENTITY_VERIFICATION_STATUS = "/checkout/get_dvs_status";
export const OMS_JUMIO_VERIFICATION_URL = "/checkout/jumio/verification";
export const OMS_JUMIO_DETAILS = "/checkout/jumio/details";
export const OMS_CUSTOMER_INFO = "/checkout/get_customer_info";
export const OMS_USER_WALLET = "/wallet/get_user_wallet";
export const OMS_WALLET_EXIST = "/orders/wallet_check";
export const OMS_CREDIT_CHECK = "/credit_checks/fetch_and_evaluate";

export const OMS_UPLOAD_IMAGE = "/checkout/upload_image";
export const OMS_UPLOAD_SCREENSHOT = "/checkout/upload_screenshot";
export const OMS_REQUEST_OTP = "/auth/otp";
export const OMS_VERIFY_OTP = "/auth/verify_otp";
export const OMS_LOG_MESSAGE = "/analytics/log_message";

export const PHONES_URL = "/shop/phones";
export const MANAGE_ORDER_URL = "/manage/order";
export const MANAGE_ORDER_URL_WITH_TERMINATE =
  "/manage/order?showTerminate=true";
export const SIM_ACTIVATION_URL = "/sim_activation/sim";
export const OMS_PROCESS_PREPAID_ORDER = "/orders/prepaid/process";
export const OMS_TRANSACTION_DETAILS = "/billing/transaction";

export const OMS_GET_CITY_LIST = "/post_offices/get_city_list";
export const OMS_GET_DISTRICT_LIST = "/post_offices/get_district_list_by_city";
export const OMS_GET_STREET_LIST =
  "/post_offices/get_street_by_district_and_city";
export const OMS_GET_STORE_LIST =
  "/post_offices/get_store_by_street_district_city";
export const OMS_ORDER_CANCELLATION_STATUS = "/cancellation/account";
export const OMS_ORDER_CANCELLATION = "/cancellation/submit";

export const OMS_POP_STATIONS = "/checkout/popstations";

export const OMS_VALIDATE_SIGNATURE = "/auth/validate_signature";
export const OMS_OUTSTANDING_BILLS = "/billing/outstanding_bills";
export const OMS_PAY_OUTSTANDING_BILLS = "/billing/pay_outstanding_bills";
export const OMS_CHECK_PAYMENT_STATUS = "/transaction/status";

export const OMS_MYINFO = "/checkout/myinfo";
export const OMS_MYINFO_SEND_OTP = "/checkout/myinfo/send_otp";
export const OMS_MYINFO_VERIFY_OTP = "/checkout/myinfo/verify_otp";
export const OMS_SUBMIT_BIIC_BIIS = "/international_telco_settings/submit";

/** User service APIs */
export const USER_SERVICE_LOGIN = `/v4/${COUNTRY}/{LOCALE}/webfront/users/login/action`;
export const USER_SERVICE_OTP = `/v4/${COUNTRY}/{LOCALE}/webfront/otp`;
export const USER_SERVICE_AUTHENTICATE = `/v4/${COUNTRY}/{LOCALE}/webfront/users/auth`;
export const USER_SERVICE_REFRESH_TOKEN = `/v4/${COUNTRY}/${LOCALE}/webfront/users/token`;
export const USER_SERVICE_LOGGEDIN_USER_DETAILS = `/v4/${COUNTRY}/{LOCALE}/mobile/users`;
export const USER_SERVICE_LINK_SOCIAL = `/v4/${COUNTRY}/{LOCALE}/webfront/users/link-social`;
export const USER_SERVICE_LIQUID_URL = `/v4/${COUNTRY}/en/webfront/kyc/url`;
export const USER_SERVICE_LIQUID_OCR_DATA = `/v4/${COUNTRY}/en/webfront/kyc/ocr-result`;
export const USER_SERVICE_LIQUID_OCR_REGISTER = `/v4/${COUNTRY}/en/webfront/kyc/submit`;
export const USER_SERVICE_REQUEST_OTP_V4_SECURE = `/v4/${COUNTRY}/{LOCALE}/mobile/secure-otp`;
export const USER_SERVICE_VALIDATE_OTP = `/v4/${COUNTRY}/{LOCALE}/webfront/users/otp/validate`;
export const USER_SERVICE_VALIDATE_OTP_TRIGGER = `/v4/${COUNTRY}/{LOCALE}/webfront/otp/validate/trigger`;
export const USER_SERVICE_UPDATE_EMAIL = `/v4/${COUNTRY}/{LOCALE}/webfront/users/attributes`;
export const USER_LOGOUT_PATH = "/users/logout";
export const USER_SERVICE_LOGOUT = `/v4/${COUNTRY}/{LOCALE}/webfront${USER_LOGOUT_PATH}`;
export const USER_SERVICE_USER_KYC = `/v4/${COUNTRY}/{LOCALE}/webfront/fetch-mno-kyc`;
export const USER_SERVICE_SUBMIT_USER_KYC = `/v4/${COUNTRY}/{LOCALE}/webfront/submit-mno-kyc`;
export const USER_SERVICE_EMAIL_OTP = `/v3/${COUNTRY}/{LOCALE}/webfront/users/auth/otp/send`;
export const USER_SERVICE_VALIDATE_EMAIL_OTP = `/v3/${COUNTRY}/{LOCALE}/webfront/users/auth/otp/validate`;

/** Api Gateway APIs */
export const API_GATEWAY_CREATE_ORDER = "/oms/orders/create_order";
export const API_GATEWAY_UPDATE_ORDER = "/oms/orders/update";
export const API_GATEWAY_APP_SETTINGS = "/oms/checkout/app_settings";
export const API_GATEWAY_LOCALE = "/oms/locale";
export const API_GATEWAY_BASE_PLAN = "/oms/checkout/base_plan";
export const API_GATEWAY_ELIGIBLE_PLANS = "/oms/checkout/eligible_plans";
export const API_GATEWAY_PAYMENT_REQUEST = "/oms/orders/payment_request";
export const API_GATEWAY_PAYMENT_DETAILS = "/oms/orders/payment_details";
export const API_GATEWAY_PAYMENT_VERIFY = "/oms/paas/v2/oms/payment/verify";
export const API_GATEWAY_MANAGE_ORDER = "/oms/manage_order";
export const API_GATEWAY_ESIM_QR = "/oms/manage_order/get_esim_qr_code";
export const API_GATEWAY_SIM_ACTIVATION_STATUS = "/oms/manage_order/sim_status";
export const API_GATEWAY_ACTIVATE_SIM_CARD = "/oms/manage_order/activate";
export const API_GATEWAY_ACTIVATE_REPLACE_SIM_CARD =
  "/oms/manage_order/activate_sim_replacement";
export const API_GATEWAY_INITIATE_PORTIN = "/oms/manage_order/initiate_portin";
export const API_GATEWAY_CANCEL_PORT_IN = "/oms/manage_order/cancel_port_in";
export const API_GATEWAY_LOG_MESSAGE = "/oms/analytics/log_message";
export const API_GATEWAY_SUBMIT_WINBACK = "/oms/termination/winback";
export const API_GATEWAY_SUBMIT_TERMINATION = "/oms/termination/submit";
export const API_GATEWAY_CANCEL_TERMINATION = "/oms/termination/cancel";
export const API_GATEWAY_DELIVERY_DETAILS = "/oms/deliveries/info";
export const API_GATEWAY_DOWNLOAD_SERVICE_AGREEMENT =
  "/oms/orders/download_service_agreement_form";
export const API_GATEWAY_DOWNLOAD_PARENTAL_CONSENT =
  "/oms/orders/download_parental_consent";
export const API_GATEWAY_VALIDATE_REFERRAL_CODE =
  "/oms/checkout/verify_referral_code";
export const API_GATEWAY_SUBMIT_DELIVERY = "/oms/deliveries/submit";
export const API_GATEWAY_REQUEST_OTP = "/oms/auth/otp";
export const API_GATEWAY_ORDER_CANCELLATION_STATUS =
  "/oms/cancellation/account";
export const API_GATEWAY_ORDER_CANCELLATION = "/oms/cancellation/submit";
export const API_GATEWAY_TRANSACTION_STATUS = "/oms/transaction/status";
export const API_GATEWAY_UPDATE_PARENTAL_CONSENT =
  "/oms/orders/parental_consent";
export const API_GATEWAY_RESUBMIT_PORTIN_DETAILS =
  "/oms/manage_order/resubmit_mnp_number";

/** Rewards service APIs */
export const REWARDS_VALIDATE_REFERRAL_CODE =
  "/user/promos/{REFERRAL_CODE}/validate";
export const REWARDS_REQUEST_WINBACK = "/winback/promotion";
export const CANCEL_TERMINATION = "/winback/claim";
/** Logistic service APIs */
export const LOGISTIC_DELIVERY_SLOTS = "/slot/libertywireless/list";

/* Payment service APIs */
export const PROCESS_CARD_UPDATE_PAYMENT_METHOD =
  "/payment/save_card/process_payment_method";
export const PROCESS_PAYMENT_METHOD = "/payment/process_payment_method";
export const SAVE_AND_GET_CARD_DETAILS = "/payment/save_and_get_card_details";
export const UPFRONT_PAYMENT = "/payment/upfront";
export const LATITUDE_TRANSACTIONS_STATUS = "/latitude_transactions/status";
export const PAYMENT_TRANSACTION_STATUS = "/transaction/status";

export const TELCO_PROFILE = "/telco/profile";
export const CREATE_PORTOUT_REQUEST = "/portouts/account/create";
export const REVERSE_PORTIN = "/portouts/account/reverse-portin";

export const BILL_DETAILS = "/customers/bills/outstanding";
export const BILL_PAYMENT_INTENT = "/customers/bills/outstanding/payintent";
export const BILL_PAYMENT_STATUS =
  "/customers/bills/outstanding/payintent/status";

/* Quilt service APIs */
export const QUILT_ELIGIBILITY = "/settings/eligibility";
export const QUILT_WINBACK_AGGREGATION = "/settings/winback-aggregation";
export const QUILT_PROFILE_AGGREGATION = "/settings/profile-aggregation";

/* Telco service APIs */
export const TELCO_REPORT_LOST_SIM = "/account-workflows/inventory/modify";
export const TELCO_REQUEST_TERMINATE = "/account-workflows/status/terminate";
export const TELCO_EMAIL_SERVICE_AGREEMENT = "/paradocs/account-subscriptions";
export const TELCO_RE_INITIATE_NUMBER_PORT_IN = "/portins/reinitiate";

/* CIS service APIs */
export const CIS_REQUEST = "/partners/request_for_cis_as_hr";
export const CIS_REQUEST_HR = "/partners/cis_request_to_hr";
export const CIS_PARTNERS = "/customers/generate_referral_code";
export const CIS_PARTNERS_REWARDS_FORM_FIELDS = "/promotions/partner";
export const CIS_PARTNERS_CMS_FORM_FIELDS = "/partners";

/*---JUMIO FULFILMENT API -----*/
export const FULFILLMENT_JUMIO_VERIFICATION_URL = "/jumio/accounts";
export const FULFILLMENT_GET_JUMIO_DETAILS = "/jumio/details";
export const FULFILLMENT_JUMIO_TOKEN = "/auth/guest-token";
const version = DEFAULT_API_VERSION[BASE.FULFILLMENT];
const basePath = VERSION_PATH[BASE.FULFILLMENT].replace("{VERSION}", version);
export const FULFILLMENT_JUMIO_CALLBACKURL = BASE_URL[BASE.FULFILLMENT] + basePath + '/jumio/callback'
// console.log("AAAA dsdsdsd :::", FULFILLMENT_JUMIO_CALLBACKURL);

/*---- SIGNPASS FULFILMENT API ----*/
export const FULFILLMENT_SIGNPASS_LINK_URL = "/myinfo/auth";
export const FULFILMENT_EXCHANGE_URL = "/myinfo/exchange";

export const FULFILLMENT_ENT_WORKFLOW = "/ent/audit_log"
export const FULFILLMENT_ACRA_UPLOAD = "/api/v1/ent/arca/workflow"
export const FULFILLMENT_ACRA_LIVENESS_CHECK = "/api/v1/ent/business/verification/workflow"
export const FULFILLMENT_ACCOUNT_HOLDER_CREATE = "/ent/arca/account_holder/create"
export const FULFILLMENT_GET_ENT_WORKFLOW = "/ent/audit_log"


export const ORDER_ACTION_TYPES = {
  SUSPEND_NUMBER: "suspend_number",
  CHANGE_NUMBER: "change_number",
  REPORT_FRAUD: "report_fraud",
  REPORT_LOST_SIM_CARD: "report_lost_sim_card",
  UPGRADE_TO_5G: "upgrade_to_5g",
  REPORT_LOST_ESIM_CARD: "report_lost_esim_card",
  TERMINATE_NUMBER: "terminate_number",
  ACTIVATE_SIM_CARD: "activate_sim_card",
  SWITCH_TO_ESIM: "switch_to_esim",
  RESEND_ESIM: "resend_esim",
  OUTSTANDING_BILLS: "pay_outstanding_bills",
  INCOMING_INTERNATIONAL_CALLS_SMS: "incoming_international_calls_sms",
  ADD_CC: "add_cc"
};

export const STEP_ACTIONS = {
  ACTIVATE_SIM_CARD: "activate_sim_card",
  INITIATE_PORTIN: "initiate_portin",
  REINITIATE_PORTIN: "reinitiate_portin",
  RESCHEDULE_PORT_IN: "reschedule_port_in",
  CANCEL_PORTIN: "cancel_portin"
};

export const RESTRICTED_STEP_ACTIONS = [
  STEP_ACTIONS.ACTIVATE_SIM_CARD,
  STEP_ACTIONS.INITIATE_PORTIN,
  STEP_ACTIONS.REINITIATE_PORTIN,
  STEP_ACTIONS.RESCHEDULE_PORT_IN,
  STEP_ACTIONS.CANCEL_PORTIN
];

export const PAYMENT_STATES = {
  PENDING_ECPAY: "PENDING_ECPAY"
};

export const PAYMENT_STATUSES = {
  PENDING: "Pending",
  SUCCESS: "Success",
  FAILED: "Failed"
};

export const SIM_ACTIVATION_STATUSES = {
  ORDER_PLACED: "OP",
  SUCCESS: "FD",
  CANCELLED: "CAN"
};

export const ORDER_ACTION_STATES = {
  SUSPENDABLE: "SUSPENDABLE",
  SUSPENSION_CANCELABLE: "SUSPENSION_CANCELABLE",
  TERMINATABLE: "TERMINATABLE",
  TERMINATE: "TERMINATE",
  CANCEL_AND_TERMINATE: "CANCEL_AND_TERMINATE",
  CANCELABLE: "CANCELABLE"
};

export const MANAGE_ORDER_FEATURE_MAPPINGS = {
  change_number: "SHOW_GUEST_ORDER_CHANGE_NUMBER_ACTION",
  suspend_number: "SHOW_GUEST_ORDER_SUSPEND_NUMBER_ACTION",
  report_lost_sim_card: "SHOW_GUEST_ORDER_REPORT_LOST_SIM_CARD_ACTION",
  upgrade_to_5g: "SHOW_GUEST_ORDER_UPGRADE_TO_5G_ACTION",
  terminate_number: "SHOW_GUEST_ORDER_TERMINATE_NUMBER_ACTION",
  cancel_termination: "SHOW_GUEST_ORDER_CANCEL_TERMINATION_ACTION",
  pay_outstanding_bills: "SHOW_GUEST_ORDER_PAY_OUTSTANDING_BILLS"
};

export const MANAGE_ORDER_TRANSLATION_MAPPINGS = {
  report_fraud: "manage_order_report_fraud",
  cancel_port_in: "manage_order_cancel_port_in",
  change_number: "manage_order_change_number",
  suspend_number: "manage_order_suspend_number",
  upgrade_to_5g: "manage_upgrade_to_5g",
  report_lost_sim_card: "manage_order_report_lost_sim_card",
  report_lost_esim_card: "manage_order_report_lost_esim_card",
  terminate_number: "manage_order_terminate_number",
  cancel_termination: "manage_order_cancel_termination",
  authorise_action: "manage_order_authorise_action",
  predeliver_action: "manage_order_predeliver_action",
  manage_order: "manage_order",
  activate_sim_card: "manage_order_activate_sim_card",
  switch_to_esim: "manage_order_switch_to_esim",
  resend_esim: "manage_order_resend_esim",
  pay_outstanding_bills: "manage_order_pay_outstanding_bills",
  update_card: "manage_order_update_card",
  incoming_international_calls_sms:
    "manage_order_incoming_international_calls_sms",
  add_cc: "manage_order_add_cc"
};

export const MANAGE_ORDER_OTP_MAPPINGS = {
  report_lost_sim_card: "email",
  upgrade_to_5g: "email",
  report_fraud: "email",
  switch_to_esim: "email",
  resend_esim: "email",
  manage_order: "email",
  pay_outstanding_bills: "email",
  update_card: "email",
  default: "sms"
};

export const MANAGE_PROFILE_OTP_MAPPINGS = {
  ENHANCED_SMS: "ENHANCED_SMS",
  ENHANCED_EMAIL_OTP: "ENHANCED_EMAIL_OTP"
};

export const MANAGE_PROFILE_REQUEST_TYPE_MAPPINGS = {
  VERIFY_MOBILE: "VERIFY_MOBILE",
  VERIFY_EMAIL_OTP: "VERIFY_EMAIL_OTP"
};

export const MANAGE_ORDER_ACTION_QUERY_PARAM_REQUIRED = {
  terminate_number: "showTerminate"
};

export const CALENDAR_YEAR_OFFSET = {
  MINGUO: 1911
};

export const PREPAID_PLAN_SUB_TYPES = ["RETAIL_PREPAID"];

export const paths = {
  LANDING_PAGE: "/",
  CHAT: "/chat",
  MANAGE_ORDER_AUTHORIZED: "/orders/authorize/:status?",
  MANAGE_ORDER: "/manage/order",
  OTP_VERIFICATION: "/manage/otp",
  CHANGE_NUMBER: "/manage/change-number",
  CHANGE_NUMBER_CONFIRMATION: "/manage/change-number-confirm",
  CHANGE_NUMBER_SUBMITTED: "/manage/change-number-submitted",
  CHANGE_NUMBER_CANCEL: "/manage/change-number/cancel-confirm",
  CHANGE_NUMBER_INELIGIBLE: "/manage/change-number/ineligible",
  CHANGE_NUMBER_FAIL: "/manage/change-number/fail",
  CHANGE_NUMBER_CANCEL_FAIL: "/manage/change-number/cancel-fail",
  REPORT_FRAUD: "/manage/report-fraud",
  REPORT_LOST_SIM: "/manage/report-lost-sim-card",
  UPGRADE_TO_5G: "/manage/upgrade-to-5g",
  REPLACE_WITH_ESIM: "/manage/esim/confirmation/:status?",
  INCOMING_INTERNATIONAL_COMMS: "/manage/incoming-international-calls-sms",
  SUSPEND_NUMBER: "/manage/suspend-number",
  SUSPEND_NUMBER_SUMMARY: "/manage/suspend-number/summary",
  SUSPEND_NUMBER_CANCEL_CONFIRMATION:
    "/manage/suspend-number/cancel-confirmation",
  SUSPEND_NUMBER_FAIL: "/manage/suspend-number/fail",
  SUSPEND_NUMBER_INELIGIBLE: "/manage/suspend-number/ineligible",
  TERMINATE_NUMBER_INELIGIBLE: "/manage/terminate-number/ineligible",
  TERMINATE_NUMBER: "/manage/terminate-number/:status?",
  CANCEL_TERMINATION: "/manage/cancel-termination/:status?",
  CANCEL_TERMINATION_SUCCESS: "/manage/cancel-termination/success",
  REQUEST_PORT_OUT: "/:channel/port-out-request",
  REVERSE_PORTIN: "/:channel/reverse-portin",
  ORDER_CANCELLATION: "/:channel/order-cancellation",
  CANCEL_PORT_IN: "/manage/cancel-port-in",
  MANAGE_RESEND_ESIM_QR: "/manage/resend-esim/:status?",
  CANCEL_PORT_IN_SUCCESS: "/manage/cancel-port-in/success",
  INITIATE_PORT_IN: "/manage/initiate-port-in",
  INITIATE_PORT_IN_SUCCESS: "/manage/initiate-port-in/success",
  REINITIATE_PORT_IN: "/manage/reinitiate-port-in",
  REINITIATE_PORT_IN_SUCCESS: "/manage/reinitiate-port-in/success",
  RESCHEDULE_PORT_IN: "/manage/reschedule-port-in",
  RESCHEDULE_PORT_IN_SUCCESS: "/manage/reschedule-port-in/success",
  OUTSTANDING_BILL_PAYMENT: "/payment/outstanding-bill-payment",
  PAYMENT_RETURN_V3: "/payment/return",
  PAYMENT_QR: "/:channel/payment-qr",
  PAYMENT: "/:channel/payment",
  PAYMENT_CARD: "/:channel/payment/card",
  PAYMENT_AMAZON: "/payment-amazon",
  PAYMENT_RETURN: "/:channel/payment-return",
  LEGACY_PAYMENT_RETURN: "/:channel/payment_return/:order_id",
  PAYMENT_STATUS: "/:channel/payment-status",
  PAYMENT_SUCCESS: "/:channel/payment-success",
  PAYMENT_FAILED: "/:channel/payment-failed",
  PAYMENT_PENDING: "/:channel/payment-pending",
  ACTIVATE: "/:channel/activate",
  ACTIVATE_SUCCESS: "/:channel/activate/success",
  PRE_CHECKOUT: "/:channel/pre-checkout",
  NEW_NUMBER: "/:channel/new-number",
  PORT_IN_NUMBER: "/:channel/keep-number",
  PERSONAL_DETAILS: "/:channel/personal-details",
  DELIVERY_INFO: "/:channel/delivery-info",
  ORDER_SUMMARY: "/:channel/order-summary",
  SIM_VERIFICATION: "/:channel/sim",
  PSIM_VERIFICATION: "/:channel/psim",
  ESIM_VERIFICATION: "/:channel/esim",
  VERIFY_IDENTITY: "/:channel/verify-identity",
  SUCCESS: "/:channel/success",
  SCHEDULE_DELIVERY: "/schedule_delivery/:order_type/:delivery_type/:status?",
  PHONES: "/:channel/phones",
  PHONE: "/shop/phones/:id",
  PHONE_DETAILS: "/:channel/phone-details",
  PAYMENT_CARD_UPDATE: "/manage/update-card",
  SHOP_ORDER_SUMMARY: "/shop/order-summary/:type",
  SHOP_PAYMENT: "/shop/payment",
  SELF_ACTIVATION_DELIVERY: "/self_act_del/order-summary",
  SELF_ACTIVATION_DELIVERY_SUCCESS: "/self_act_del/success",
  UPLOAD_IDENTITY: "/identity/:type",
  SCANNER: "/loadBarcode",
  SELF_ACTIVATION_ICCID_SCANNER: "/self_activation/scanner",
  DASHBOARD: "/dashboard",
  WEBLOGIN: "/loginweb",
  CLOSEWEBVIEW: "/closewebview",
  EKYC_VERIFY: "/ekyc_verify",
  UPDATE_CARD_SUCCESS: "/updateCardSuccess",
  PROFILE_UPDATE_EMAIL_SUCESS: "/profileUpdateEmailSuccess",
  PING: "/ping",
  ZENDESK: "/zendesk",
  SIM_ACTIVATION_ORDER_SUMMARY: "/sim_activation/order-summary",
  SIM_ACTIVATION_PAYMENT_RETURN: "/sim_activation/payment-return",
  SELF_ACTIVATION_ORDER_SUMMARY: "/self_activation/order-summary",
  SELF_ACTIVATION_EKYC: "/self_activation/ekyc",
  SURVEY: "/surveys/new",
  IDENTITY_VERIFICATION: "/identity_verification",
  PLAN_SELECTION: "/:channel/plan-selection",
  ESIM_TYPE_SELECTION: "/:channel/esim-selection",
  PHYSICAL_SIM_TYPE_SELECTION: "/:channel/physical-sim-selection",
  CONNECTION_DETAILS: "/:channel/connection-details",
  PROFILE: "/profile",
  PROFILE_EMAIL: "/:channel/email",
  USER_DETAILS_CONFIRMATION: "/:channel/user-details-confirmation",
  SIM_ACTIVATION_STATUS: "/:channel/sim-activation-status",
  SIM_ACTIVATION_SUCCESS: "/:channel/sim-activation-success",
  SIM_ACTIVATION_PENDING: "/:channel/sim-activation-pending",
  USER_DETAILS: "/web/user-details",
  AU_USER_DETAILS: "/web/au-user-details",
  OWNER_DETAILS: "/web/owner-details",
  PORTIN_DETAILS: "/web/portin-details",
  DELIVERY_DETAILS: "/web/delivery-details",
  CONTACT_DETAILS: "/web/contact-details",
  MANAGE_SIM_ACTIVATION: "/manage/sim-activation",
  MANAGE_ACTIVATE_SIM_CARD: "/manage/activate-sim-card",
  MANAGE_SIM_ACTIVATION_SUCCESS: "/manage/sim-activation-success",
  MANAGE_ESIM_QR: "/manage/esim-qr",
  LOG_IN: "/:channel/login",
  LOGGED_OUT: "/logged_out",
  APP_LINK_AU_ACCOUNT_SUCCESS: "/auidLinkingSuccess",
  SIM_REPLACEMENT_CONNECTION_DETAILS:
    "/:channel/sim-replacement-connection-details",
  SIM_REPLACEMENT_ESIM_ACTIVATION: "/manage/replace-sim-esim-qr",
  SIM_REPLACEMENT_DELIVERY_DETAILS: "/web/replace-sim-delivery-details",
  SIM_REPLACEMENT_CONTACT_DETAILS: "/web/sim-replacement-contact-details",
  SELF_ACTIVATION_SIM_DELIVERY: "/:channel/sa_delivery",
  EKYC: "/:channel/ekyc",
  SELF_ACTIVATION_PLAN: "/:channel/plan",
  SCHEDULE_DELIVERY_CONFIRMATION: "/confirmation",
  PORTIN_NUMBER_SELECTION: "/:channel/portin-number-selection",
  VERIFY_IDENTITY_ORDER_SUMMARY: "/verify-identity/order-summary",
  CHANNEL_OTP: "/:channel/otp",
  PORT_IN_CHANNEL_OTP: "/:channel/port_in_otp",
  CIS_REQUEST: "/cis/request_for_cis",
  CIS_REQUEST_HR: "/cis/request_for_cis_to_hr",
  CIS_REQUEST_SUCCESS: "/cis/request_for_cis/success",
  CIS_REQUEST_HR_SUCCESS: "/cis/request_for_cis_to_hr/success",
  DIRECT_LINK_EXPIRED: "/payment/link_expired",
  OUTSTANDING_BILLS: "/payment/outstanding_bills",
  OUTSTANDING_BILLS_PAYMENT_STATUS: "/payment/outstanding_bills/:status",
  OUTSTANDING_BILLS_PAYMENT_STATUS_SUCCESS:
    "/payment/outstanding_bills/success",
  OUTSTANDING_BILLS_PAYMENT_STATUS_FAILURE: "/payment/outstanding_bills/fail",
  OUTSTANDING_BILLS_PAYMENT_STATUS_IN_PROGRESS:
    "/payment/outstanding_bills/in_progress",
  WIRE_CARD_ONE_TIME_PAYMENT: "/wirecard/ipp/one-time-payment",
  SWITCH_TO_ESIM: "/manage/switch-to-esim",
  MANAGE_ACTION_GENERIC_STATUS: "/manage/:action/:status",
  CIS_PARTNERS_SUCCESS: "/partners/success",
  CIS_PARTNERS: "/partners/:partnerID",
  CIRCLES1_SAD: "/circles1/sa_delivery",
  CIRCLES1_DEALS: "/circles1/deals",
  PLANS: "/:channel/plans",
  ERROR_404: "/404",
  ERROR_500: "/500",
  MAINTENANCE: "/maintenance",
  ENTERPRISE_AUTOMATED_ONBOARDING: "/:channel/automated-onboarding",
  ENTERPRISE_AUTOMATED_EKYC: "/:channel/automated-ekyc",
  ENTERPRISE_AUTOMATED_COMPANY_DETAILS: "/:channel/automated-company-details",
  ENTERPRISE_AUTOMATED_ACCOUNT_DETAILS: "/:channel/automated-account-details",
  ENTERPRISE_AUTOMATED_REVIEW_ORDER: "/:channel/automated-review-order",
  ENTERPRISE_AUTOMATED_PAYMENT_RETURN: "/:channel/automated-payment-return",
  ENTERPRISE_AUTOMATED_VERIFICATION: "/:channel/automated-verification",
};

export const forms = {
  PRE_CHECKOUT_FORM: "PreCheckoutForm",
  PERSONAL_DETAILS_FORM: "PersonalDetailsForm",
  CONNECTION_DETAILS_FORM: "ConnectionDetailsForm",
  PORT_IN_FORM: "PortInForm",
  NEW_NUMBER_FORM: "NewNumberForm",
  DELIVERY_INFO_FORM: "DeliveryInfoForm",
  ORDER_SUMMARY_FORM: "OrderSummaryForm",
  SIM_VERIFICATION_FORM: "SimVerificationForm",
  IDENTITY_VERIFICATION_FORM: "IdentityVerificationForm",
  SELF_ACTIVATION_FORM: "SelfActivationForm",
  UPLOAD_IDENTITY_FORM: "UploadIdentityForm",
  SHOP_PAYMENT_FORM: "ShopPaymentForm",
  MANAGE_ORDER_FORM: "ManageOrderForm",
  OUTSTANDING_BILLS_FORM: "OutstandingBillsForm",
  USER_LOGIN_FORM: "UserLoginForm",
  USER_LOGIN_OTP_FORM: "UserLoginOTPForm",
  USER_SIGNUP_FORM: "UserSignupForm",
  USER_DETAILS_CONFIRMATION_FORM: "UserDetailsConfirmationForm",
  PHONES_FORM: "PhonesForm",
  PAYMENT_FORM: "PaymentForm",
  UPGRADE_TO_5G_FORM: "UpgradeTo5GForm",
  REPORT_LOST_SIM_FORM: "ReportLostSimForm",
  REPORT_FRAUD_FORM: "ReportFraudForm",
  REQUEST_PORTOUT_FORM: "RequestPortOutForm",
  REVERSE_PORTIN_FORM: "ReversePortInForm",
  ORDER_CANCELLATION_FORM: "OrderCancellationForm",
  PROFILE_FORM: "ProfileForm",
  PORTIN_NUMBER_SELECTION_FORM: "PortInNumberSelectionForm",
  TERMINATION_STATUS_FORM: "TerminationStatusForm",
  OUTSTANDING_BILL_PAYMENT_FORM: "OutstandingBillPaymentForm",
  SUSPEND_NUMBER_FORM: "SuspendNumberForm",
  WIRECARD_ONE_TIME_PAYMENT_FORM: "WireCardOneTimePaymentForm",
  CHANGE_NUMBER_FORM: "ChangeNumberForm",
  AUTHORIZER_FORM: "AuthorizerForm",
  SWITCH_TO_ESIM_FORM: "SwitchToEsimForm",
  TERMINATE_NUMBER_FORM: "TerminateNumberForm",
  CHANNEL_OTP_FORM: "ChannelOTPForm",
  CIS_REQUEST_FORM: "CisRequestForm",
  CIS_REQUEST_HR_FORM: "CisRequestHrForm",
  CIS_PARTNERS_FORM: "CisPartnersForm",
  INCOMING_INTERNATIONAL_CALLS_SMS_FORM: "IncomingInternationalCallsSMSForm"
};

export const DEFAULT_KEYS_TO_FETCH = ["appSettings", "locale", "eligiblePlans"];

export const PENDING = "PENDING";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const STATUS = "STATUS";

export const ACTION_URLS = {
  activate_sim_card: paths.ACTIVATE,
  initiate_portin: paths.INITIATE_PORT_IN,
  reinitiate_portin: paths.REINITIATE_PORT_IN,
  reschedule_port_in: paths.RESCHEDULE_PORT_IN,
  cancel_portin: paths.CANCEL_PORT_IN,
  payment_status: paths.PAYMENT_STATUS,
  payment_success: paths.PAYMENT_SUCCESS,
  payment_pending: paths.PAYMENT_PENDING,
  payment_failed: paths.PAYMENT_FAILED,
  reupload_identity: paths.UPLOAD_IDENTITY,
  report_lost_esim_card: paths.REPORT_LOST_SIM,
  report_fraud: paths.REPORT_FRAUD,
  pay_outstanding_bills: paths.OUTSTANDING_BILLS,
  update_card: paths.OUTSTANDING_BILLS,
  incoming_international_calls_sms: paths.INCOMING_INTERNATIONAL_COMMS,
  upgrade_to_5g: paths.UPGRADE_TO_5G
};

export const PAYMENT_STATUS_URLS = {
  success: paths.PAYMENT_SUCCESS,
  pending: paths.PAYMENT_PENDING,
  failed: paths.PAYMENT_FAILED
};

export const OUTSTANDING_PAYMENT_STATUS_URLS = {
  [SUCCESS]: paths.OUTSTANDING_BILLS_PAYMENT_STATUS_SUCCESS,
  [PENDING]: paths.OUTSTANDING_BILLS_PAYMENT_STATUS_IN_PROGRESS,
  [FAILURE]: paths.OUTSTANDING_BILLS_PAYMENT_STATUS_FAILURE,
  [STATUS]: paths.OUTSTANDING_BILLS_PAYMENT_STATUS.replace(":status", "status")
};

export const WEBSITE_V2 = "website_v2";
export const SELF_ACT_DEL = "self_act_del";
export const SELF_ACTIVATION_SIM = "self_activation";
export const SIM_ACTIVATION = "sim_activation";
export const ESIM = "esim";
export const PSIM = "psim";
export const SIM = "sim";
export const ENTERPRISE = "enterprise"

export const ORDER_CHANNEL_MAPPING = {
  web: WEBSITE_V2,
  enterprise: WEBSITE_V2,
  website: WEBSITE_V2,
  circles2: WEBSITE_V2,
  circles100: WEBSITE_V2,
  combo: WEBSITE_V2,
  phoneonly: WEBSITE_V2,
  dataonly: WEBSITE_V2,
  circles3: WEBSITE_V2,
  circles10: WEBSITE_V2,
  circles25: WEBSITE_V2,
  circles45: WEBSITE_V2,
  circles55: WEBSITE_V2,
  shop: SELF_ACT_DEL,
  circles1: SELF_ACT_DEL,
  familyplan: SELF_ACT_DEL,
  circleslarpu: SELF_ACT_DEL,
  self_activation: SIM_ACTIVATION,
  "e-sim": ESIM
};

export const ROOT_CHANNEL = ":channel";
export const PHONE_ONLY_CHANNEL = "phoneonly";
export const COMBO_CHANNEL = "combo";
export const CIRCLES1_CHANNEL = "circles1";
export const CIRCLES2_CHANNEL = "circles2";
export const CIRCLES3_CHANNEL = "circles3";
export const CIRCLES100_CHANNEL = "circles100";
export const CIRCLES10_CHANNEL = "circles10";
export const CIRCLES25_CHANNEL = "circles25";
export const CIRCLES45_CHANNEL = "circles45";
export const CIRCLES55_CHANNEL = "circles55";
export const FAMILY_PLAN = "familyplan";
export const CIRCLESLARPU = "circleslarpu";
export const WEB_CHANNEL = "web";
export const PARTNERS_CHANNEL = "partners";
export const ROADSHOW_CHANNEL = "roadshow";
export const PAYMENT_CHANNEL = "payment";
export const ESIM_CHANNEL = "e-sim";
export const DATA_ONLY_CHANNEL = "dataonly";
export const O2O_CHANNEL = "o2o";
export const SHOP_CHANNEL = "shop";
export const ENTERPRISE_AUTOMATED_CHANNLE = "enterprise-automation"

export const WEB_CHANNELS = [
  WEB_CHANNEL,
  "website",
  "website_v2",
  CIRCLES1_CHANNEL,
  CIRCLES2_CHANNEL,
  CIRCLES100_CHANNEL,
  COMBO_CHANNEL,
  DATA_ONLY_CHANNEL,
  CIRCLES3_CHANNEL,
  FAMILY_PLAN,
  CIRCLESLARPU,
  PHONE_ONLY_CHANNEL,
  "liveon2",
  "liveon3",
  "liveon4",
  "liveon5",
  "liveon6",
  "liveon7",
  "cis",
  ESIM_CHANNEL,
  ROADSHOW_CHANNEL,
  CIRCLES10_CHANNEL,
  CIRCLES25_CHANNEL,
  CIRCLES45_CHANNEL,
  CIRCLES55_CHANNEL,
  O2O_CHANNEL,
  SHOP_CHANNEL
];

export const SIM_ACTIVATION_CHANNELS = [
  "sim_activation",
  "sim_activation_id",
  "blackhawk",
  "self_activation",
  "e-sim"
];

export const AU_TO_POVO_CHANNEL = "au_to_povo";
export const DEFAULT_CHANNEL = "circles1";

export const WORKFLOW_CHANNELS = [
  ...WEB_CHANNELS,
  ...SIM_ACTIVATION_CHANNELS,
  AU_TO_POVO_CHANNEL
];

export const TELCO_BENEFIT_TYPES = {
  TELCO_DATA: "telco_data",
  TELCO_VOICE: "telco_voice",
  TELCO_SMS: "telco_sms",
  TELCO_ADDON: "telco_addon"
};

export const TELCO_WAIVER_TYPES = {
  TELCO_BILL_WAIVER: "telco_bill_waiver",
  TELCO_ADDON_WAIVER: "telco_addon_waiver"
};

export const TELCO_DISCOUNT_TYPES = {
  TELCO_REGISTRATION_DISCOUNT: "telco_registration_discount",
  TELCO_SUBSCRIPTION_DISCOUNT: "telco_subscription_discount"
};

export const ONE_TIME_DISCOUNT_TYPES = [
  TELCO_DISCOUNT_TYPES.TELCO_REGISTRATION_DISCOUNT,
  TELCO_DISCOUNT_TYPES.TELCO_SUBSCRIPTION_DISCOUNT
];

export const NON_TELCO_BENEFIT_TYPES = {
  DEVICE_VOUCHER: "enb"
};

export const STANDALONE_WORKFLOW_PATHS = [
  "/web/activate",
  "/web/success",
  "/web/login",
  "/web/signup",
  "/web/confirm-email",
  "/web/verify-otp",
  "/web/user-details",
  "/web/owner-details",
  "/web/portin-details",
  "/web/delivery-details",
  "/web/contact-details",
  "/verify-identity/ekyc",
  "/verify-identity/order-summary",
  "/verify-identity/success",
  "/au_to_povo/login",
  "/au_to_povo/signup",
  paths.CIS_REQUEST,
  paths.CIS_REQUEST_HR
];

export const STANDALONE_WORKFLOW_ROUTES = [
  paths.PAYMENT_SUCCESS,
  paths.PHONES,
  paths.PHONE_DETAILS,
  paths.CIRCLES1_DEALS,
  paths.PLANS,
  paths.SIM_VERIFICATION,
  paths.PSIM_VERIFICATION,
  paths.ESIM_VERIFICATION
];

export const DEFAULT_TERMINATION_REASONS = [
  "termination_reason_different_number",
  "termination_reason_contract",
  "termination_reason_incorrect_details",
  "termination_reason_mind",
  "termination_reason_other"
];

// These paths are open to all visitors
export const publicPaths = {
  LOGIN_PAGE: "/:channel/login",
  SIGNUP_PAGE: "/:channel/signup",
  CONFIRM_EMAIL: "/:channel/confirm-email",
  SELECT_EMAIL: "/:channel/select-email",
  VERIFY_OTP: "/:channel/verify-otp",
  LINE_AUTHENTICATION: "/line_authentication",
  YAHOO_AUTHENTICATION: "/yahoo_authentication",
  GOOGLE_AUTHENTICATION: "/google_authentication",
  FACEBOOK_AUTHENTICATION: "/facebook_authentication",
  APPLE_AUTHENTICATION: "/apple_authentication",
  AU_AUTHENTICATION: "/au_authentication",
  AU_LOST_SERVICE: "/au_lost_service",
  //TODO This is added only for testing purpose , need to remove this after au lost service page is developed
  MOCK_AU_LOST_SERVICE: "/dummy_au_lost_service",
  AU_LOST_SERVICE_USER_CONFIRM: "/:channel/au-lost-service-user-confirm"
};

export const AUTH_MODES = {
  ENHANCED_EMAIL_OTP: "ENHANCED_EMAIL_OTP"
};
// This is the default web view value send by the mobile application via query params
export const DEFAULT_WEB_VIEW_VALUE = "1";
export const tabTypes = {
  PILL: "PILL"
};

// constant to check whether payment action is a redirect or submit
export const POST_PAYMENT_REQUEST_ACTION_TYPES = {
  SUBMIT: "submit",
  REDIRECT: "redirect"
};

export const PAYMENT_METHODS = {
  AMAZON_PAY: "amazonPay",
  APPLE_PAY: "applePay",
  GOOGLE_PAY: "googlePay"
};

export const PAYMENT_TYPE = {
  WALLET_PAYMENT: "wallet payment"
};

export const NODE_ENVIRONMENT = {
  DEVELOPMENT: "development",
  PRODUCTION: "production"
};

export const IS_PRODUCTION =
  process.env.NODE_ENV === NODE_ENVIRONMENT.PRODUCTION;

export const CALL_BACK_URL = {
  LINE: `${window.location.origin}${publicPaths.LINE_AUTHENTICATION}`,
  YAHOO: `${window.location.origin}${publicPaths.YAHOO_AUTHENTICATION}`,
  GOOGLE: `${window.location.origin}${publicPaths.GOOGLE_AUTHENTICATION}`,
  FACEBOOK: `${window.location.origin}${publicPaths.FACEBOOK_AUTHENTICATION}`,
  AMAZON_PAY: `${window.location.origin}${paths.PAYMENT_AMAZON}`,
  APPLE: `${window.location.origin}${publicPaths.APPLE_AUTHENTICATION}`,
  AU: `${window.location.origin}${publicPaths.AU_AUTHENTICATION}`,
  AU_LOST_SERVICE: `${window.location.origin}${publicPaths.AU_LOST_SERVICE}`
};

export const SIM_TYPES = {
  PHYSICAL_SIM: "PHYSICAL_SIM",
  E_SIM: "E_SIM",
  PHYSICALSIM: "physicalsim",
  ESIM: "esim",
  PSIM: "psim"
};

export const CONTRACT_TYPES = {
  NEW: "NEW",
  PORT_IN: "PORT_IN"
};

export const EXPRESS_DELIVERY = "Express Delivery";
export const SPECIAL_DELIVERY = "Special Delivery";

export const NUMBER_TYPES = {
  PORT_IN: "port_in",
  NEW_NUMBER: "new_number"
};

export const PHONE_PAYMENT_OPTIONS = {
  FULL: "full",
  IPP: "installment",
  SPLIT: "split"
};

export const OUTSTANDING_BILL_REFERRAL_FROM_TYPE = {
  MANAGE_ORDER: "MANAGE_ORDER",
  DIRECT_LINK: "DIRECT_LINK"
};

export const RESPONSE_STATUS = {
  FAILURE: "FAILURE",
  SUCCESS: "SUCCESS",
  SUBMITTED: "SUBMITTED"
};

export const SOCIAL_MEDIA_TYPES = {
  LINE: "LINE",
  YAHOOJP: "YAHOOJP",
  GOOGLE: "GOOGLE",
  FACEBOOK: "FACEBOOK",
  APPLE: "APPLE",
  TWITTER: "TWITTER",
  AU_LOGIN: "AU"
};

export const COUNTRIES = {
  JP: "jp"
};

export const ERROR_CODES = {
  missingResourceForSubmitKycRequest: 400119
};

export const TERMINATE_ACTION_STATUS = {
  UNFINISHED: "UNFINISHED",
  FAIL: "FAIL"
};

export const PORTOUT_IN_PROGRESS = "IN_PROGRESS";
export const TERMINATION_PENDING_STATUSES = [
  "REGISTERED",
  "PENDING",
  "SUBMITTED",
  "IN_PROGRESS",
  "UNFINISHED"
];
export const PORTOUT_PENDING_STATUSES = [
  "ONGOING_QUEUED",
  "QUEUED",
  "ONGOING_PUBLISHED",
  "PUBLISHED",
  PORTOUT_IN_PROGRESS
];
export const PORTOUT_FAILED_STATUSES = ["FAILED"];
export const PORTOUT_COMPLETED_STATUSES = [
  "NETWORK_PORTOUT",
  "SCHEDULED_TERMINATION",
  "DONE"
];

export const ESIM_FAQ_URL =
  "https://circlesasiasupport.zendesk.com/hc/en-us/categories/900000106743-ESIM";

export const PLAN_SOURCE_COMBO = "SPLIT_COMBO_FLOW";
export const PLAN_SOURCE_PHONE_ONLY = "SPLIT_PHONE_ONLY";
export const PLAN_SOURCE_DEFAULT = "DEFAULT";
export const REPORT_LOST_SIM_REASON = "Customer initiated due to lost sim";
export const REPORT_FRAUD_REASON = "report_fraud";

export const DELIVERY_METHOD_TYPE = {
  HOME: "home",
  POP_STATION: "pop_station",
  INSTANT_PICK_UP: "instant_pick_up"
};
//contains value to differentiate between our default page flow or a direct link
export const REFERER_TYPE = {
  DEFAULT: "DEFAULT",
  DIRECT_LINK: "DIRECT_LINK"
};

export const LOGIN_REDIRECT_CHANNEL_MAPPING = {
  [AU_TO_POVO_CHANNEL]: DEFAULT_CHANNEL
};

export const VERIFY_IDENTITY_CHANNEL = "verify-identity";

export const TRANSACTION_STATUS_TIMEOUT = 10;

export const STATUS_TYPE = {
  TRANSACTION: "transaction"
};

export const PAYMENT_TYPES = {
  ADYEN: "adyen",
  STRIPE: "stripe"
};

export const LOST_SIM = "LOST_SIM";

export const STD = "STD";

export const DOB_SEPARATOR = "-";
export const DOB_FORMAT = "DD-MM-YYYY";
export const SECURITY_DOB_FORMAT = "YYYY-MM-DD";
export const KYC_DOB_FORMAT = "YYYYMMDD";
export const JP_DOB_FORMAT = "YYYY年MM月DD日";
export const PRODUCT_TYPE = { addon: "ADDON", nilclass: "NilClass" };

export const OUTSTANDING_PAYMENT_STATUS = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  SUCCESS: "OK"
};

export const OUTSTANDING_BILL_STATUS = {
  OK: "OK",
  INVALID_SYNC_OR_SEND_STATUS: "INVALID_SYNC_OR_SEND_STATUS",
  NO_OPEN_BILLS: "NO_OPEN_BILLS",
  IN_PROGRESS: "IN_PROGRESS"
};

export const UPDATE_TOKEN_TO_APP_URI = "webfront://updatetoken";

export const CountryCode = {
  SG: "sg",
  ID: "id",
  TW: "tw",
  JP: "jp",
  AU: "au"
};

export const BUTTON_THROTTLE_SETTINGS = {
  TIME_DELAY: 1000,
  THROTTLE_SETTINGS: {
    trailing: false
  }
};

// http status error codes
export const CONFLICTING_ORDERS_STATUS = 409;
export const UNAUTHORIZED_HTTP_CODE = 401;
export const TOKEN_INVALID_HTTP_CODE = 403;

//Recaptcha error codes
export const RECAPTURE_TOKEN_BROWSER_ERROR = 401015;

// JUMIO verification return query params
export const JUMIO_PARAMS = {
  TRANSACTION_STATUS: "transactionStatus",
  CUSTOMER_INT_REF: "customerInternalReference",
  TRANSACTION_REF: "transactionReference",
  ERROR_CODE: "errorCode",
  REJECT_REASON: "rejectReason",
  COUNTRY: "idCountry",
  STATUS_SUCCESS: "SUCCESS",
  GL: "_gl",
  VERIFICATION_STATUS: "APPROVED_VERIFIED",
};

// MYINFO return query params
export const MYINFO_PARAMS = {
  CODE: "code",
  STATE: "state",
  ERROR: "error",
  STATE_200: "200"
};

export const PHONEONLY_PARAM_SOURCE = {
  XP_UNLIMITED: "unlimited-xp",
  EARN_AND_BURN: "enb"
};

export const USE_PHONE_WALLET_SOURCE_PARAMS = Object.values(
  PHONEONLY_PARAM_SOURCE
);

export const NUMBER_CATEGORY = {
  FREE: "Free",
  SILVER: "Silver",
  GOLDEN: "Golden"
};

export const CONVERSION_VALUE = 1024;

export const PHONE_NOT_AVAIALBLE = "NOT AVAILABLE";

export const REPLIT_REDIRECT_URL = "https://circles-business-account-onboarding.replit.app"


export const IMDA_ERROR_STATES = {
  NOT_ELIGIBLE: "NOT_ELIGIBLE",
  IMDA_SERVER_DOWN: "IMDA_SERVER_DOWN",
  BLACKLISTED: "BLACKLISTED"
};

export const ENTERPRISE_AUTOMATED = {
  ESIM: 'eSIM',
  PSIM: 'pSIM',
  THUMBS_UP_ICON:"https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ENT+webfront/thumbs+up+icon.png",
  NEW_NUMBER_ICON:"https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ENT+webfront/new+number+icon.png",
  TRASNFER_NUMBER_ICON:"https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ENT+webfront/transfer+number+icon.png",
  NAVIGATE_URL: "/enterprise/automated-company-details"
}